module.exports = __webpack_public_path__ + "static/img/logo-color.351a798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-color.png
// module id = U880
// module chunks = 1